import { useLayoutEffect, useState, useEffect, useCallback } from "react";
import DataGrid, {
  Column,
  HeaderFilter,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { DefaultDateFormat } from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useLocation, useNavigate } from "react-router-dom";
import "./../../../App.css";
import moment from "moment";
import { useSelector } from "react-redux";
import { askConfirmation, showResponseMessage } from "../../../helper/message";

export default function ViewAssetScrapRequestComponent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [assetScrapRequestInfo, setAssetScrapRequestInfo] = useState(null);
  const [assetScrapSubLst, setAssetScrapSubLst] = useState([]);
  const [isAssetScrapApproved, setIsAssetScrapApproved] = useState(false);
  const [isAssetScrapSendBackToDraft, setIsAssetScrapSendBackToDraft] =
    useState(false);
  const [isAssetScrapRollBack, setIsAssetScrapRollBack] = useState(false);
  const [assetScrapHistoryLst, setAssetScrapHistoryLst] = useState([]);
  const [requestId, setRequestId] = useState([]);
  const user = useSelector((state) => state.user.data);

  useLayoutEffect(() => {
    document.querySelector(
      "#pageTitle"
    ).innerHTML = `Asset Scrap Request Preview`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      var requestId = 0;
      requestId =
        location.state?.stateData !== null &&
        location.state?.stateData !== undefined
          ? location.state?.stateData?.id
          : location.state?.requestId;

      setTimeout(async () => {
        // await getAssetScrapRequestInfo(
        //   location.state?.stateData?.id,
        //   user?.userId
        // );
        await getAssetScrapRequestInfo(requestId, user?.userId);
      }, 0);
      setTimeout(async () => {
        //await getAssetScrapSubLst(location.state?.stateData?.id);
        await getAssetScrapSubLst(requestId);
      }, 0);
      setTimeout(async () => {
        //await getAssetScrapHistoryLst(location.state?.stateData?.id);
        await getAssetScrapHistoryLst(requestId);
      }, 0);

      setRequestId(
        location.state?.stateData !== null &&
          location.state?.stateData !== undefined
          ? location.state?.stateData?.id
          : location.state?.requestId
      );
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetScrapRequestInfo = async (assetScrapId, userId) => {
    try {
      const response = await assetService.getAssetScrap(assetScrapId, userId);
      setAssetScrapRequestInfo(response?.data[0] ?? null);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetScrapSubLst = async (assetScrapId) => {
    try {
      const response = await assetService.getAssetScrapSub(assetScrapId);
      setAssetScrapSubLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetScrapHistoryLst = async (assetScrapId) => {
    try {
      const response = await assetService.getAssetScrapHistory(assetScrapId);
      setAssetScrapHistoryLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnApproveAssetScrap = async (e) => {
    e.preventDefault();
    try {
      let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to approve asset scrap?</span>`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );
      if (!isConfirmed) return;
      setIsAssetScrapApproved(true);
      const response = await assetService.approveAssetScrap(
        parseInt(requestId),
        parseInt(user?.userId)
      );
      isConfirmed = await showResponseMessage(response);
      setIsAssetScrapApproved(false);
      if (response?.isSuccess) {
        window.location.href = "/AssetScrap";
      }
    } catch (error) {
      setIsAssetScrapApproved(false);
      console.log(error);
    }
  };

  const handleOnBackToNormalAssetScrap = async (e) => {
    e.preventDefault();
    try {
      let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to send back to normal asset scrap?</span>`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );
      if (!isConfirmed) return;
      setIsAssetScrapSendBackToDraft(true);
      const response = await assetService.sendBackToNormalAssetScrap(
        parseInt(requestId),
        parseInt(user?.userId)
      );
      isConfirmed = await showResponseMessage(response);
      setIsAssetScrapSendBackToDraft(false);
      if (response?.isSuccess) {
        window.location.href = "/AssetScrap";
      }
    } catch (error) {
      setIsAssetScrapSendBackToDraft(false);
      console.log(error);
    }
  };

  const handleOnRecallAssetScrap = async (e) => {
    e.preventDefault();
    try {
      let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to recall asset scrap?</span>`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );
      if (!isConfirmed) return;
      setIsAssetScrapRollBack(true);
      const response = await assetService.recallAssetScrap(
        location.state?.stateData?.id,
        user?.userId
      );
      isConfirmed = await showResponseMessage(response);
      setIsAssetScrapRollBack(false);
      if (response?.isSuccess) {
        window.location.href = "/AssetScrap";
      }
    } catch (error) {
      setIsAssetScrapRollBack(false);
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card top-bottom" style={{ marginTop: "-10px" }}>
          <div className="card-body">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={() => {
                if (!location?.state?.isReport) {
                  navigate("/AssetScrap");
                } else {
                  navigate("/ReportAssetScrap");
                }
              }}
            >
              <span title="Back ">
                <i className="fas fa-arrow-left" />
                &nbsp;&nbsp;Back
              </span>
            </button>
            {assetScrapRequestInfo?.isApproved && (
              <>
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={async (e) => {
                    await handleOnApproveAssetScrap(e);
                  }}
                  disabled={isAssetScrapApproved}
                >
                  <span title="Approve">
                    <i
                      className={`fas fa-${
                        isAssetScrapApproved ? "spinner fa-spin" : "check"
                      }`}
                    />
                    &nbsp;&nbsp;Approve
                  </span>
                </button>
              </>
            )}
            {assetScrapRequestInfo?.isSendBackToDraft && (
              <>
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={async (e) => {
                    await handleOnBackToNormalAssetScrap(e);
                  }}
                  disabled={isAssetScrapSendBackToDraft}
                >
                  <span title="Back to Draft">
                    <i
                      className={`fas fa-${
                        isAssetScrapSendBackToDraft
                          ? "spinner fa-spin"
                          : "check"
                      }`}
                    />
                    &nbsp;&nbsp;Back to Draft
                  </span>
                </button>
              </>
            )}
            {assetScrapRequestInfo?.isRollBack && (
              <>
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm"
                  onClick={async (e) => {
                    await handleOnRecallAssetScrap(e);
                  }}
                  disabled={isAssetScrapRollBack}
                >
                  <span title="Recall">
                    <i
                      className={`fas fa-${
                        isAssetScrapRollBack ? "spinner fa-spin" : "check"
                      }`}
                    />
                    &nbsp;&nbsp;Recall
                  </span>
                </button>
              </>
            )}
            &nbsp;&nbsp;
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => {
                window.print();
              }}
            >
              <span title="Print">
                <i className="fas fa-print" />
                &nbsp;&nbsp;Print
              </span>
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-9">
            <div className="card">
              <div className="card-body">
                <table width="100%" className="page-header">
                  <tr>
                    <td>
                      <div className="imglogo mt-2">
                        <img
                          src="https://vishwasamudra.in/wp-content/uploads/2022/11/New-Project.png"
                          alt="DigilinkZ | Streamlining Storage, Access & Organization"
                          width="150"
                          class=""
                        />
                      </div>
                    </td>
                    <td align="right">
                      <h6
                        className="mb-1"
                        style={{ fontSize: "0.8rem", color: "#282C7D" }}
                      >
                        Registered Office
                      </h6>
                      <p className="mb-0 pb-0 small">
                        8th & 9th Floors, Vamsiram Jyothi Valencia,<br></br>
                        Road No. 2, Banjara Hills, Hyderabad – 500034
                      </p>
                    </td>
                  </tr>
                </table>
                <div
                  className="text-center mt-5 mb-4 imo-page-title"
                  style={{
                    backgroundColor: "#ebebeb",
                    paddingTop: "7px",
                    paddingBottom: "7px",
                    border: "1px solid #ebebeb",
                  }}
                >
                  <table width="100%">
                    <tr>
                      <td className="text-center">
                        <h4
                          className="mb-0"
                          style={{ fontWeight: "700", color: "#282c7d" }}
                        >
                          ASSET SCRAP REQUEST
                        </h4>
                        <h6 className="mb-0 mr-3" style={{ fontWeight: "600" }}>
                          {assetScrapRequestInfo?.assetScrapRequestNo ?? ""}
                        </h6>
                      </td>
                    </tr>
                  </table>
                </div>
                <div className="imo-basic-detail">
                  <table cellPadding="2">
                    <tr>
                      <td width="80px" style={{ fontSize: "0.9rem" }}>
                        From
                      </td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetScrapRequestInfo?.fromUserName ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>To</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetScrapRequestInfo?.toUserName ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Site</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetScrapRequestInfo?.projectName ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Scrap No.</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetScrapRequestInfo?.assetScrapRequestNo ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Note</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetScrapRequestInfo?.note ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Date</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetScrapRequestInfo?.requestedDate
                          ? moment(assetScrapRequestInfo?.requestedDate)
                              .format(DefaultDateFormat.MomentDisplayDateFormat)
                              .toString()
                          : ""}
                      </td>
                    </tr>
                  </table>
                </div>
                <div>
                  <hr></hr>
                </div>
                <div className="message-body">
                  <DataGrid
                    dataSource={assetScrapSubLst}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    showRowLines={true}
                    showColumnLines={false}
                    height={300}
                  >
                    <Column
                      dataField="assetSerialNo"
                      caption="Asset Description"
                      allowSearch={true}
                      allowSorting={true}
                      cellRender={(data) => {
                        return (
                          <>
                            <span>{data?.data?.assetSerialNo ?? ""}</span>
                            {data?.data?.categoryName &&
                              data?.data?.subCategoryName && (
                                <>
                                  <br />
                                  <small>
                                    {data?.data?.categoryName}
                                    {"  >  "}
                                    {data?.data?.subCategoryName}
                                  </small>
                                </>
                              )}
                          </>
                        );
                      }}
                    />
                    <Column
                      dataField="scrapReason"
                      caption="Reason"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Column
                      dataField="qty"
                      caption="Qty"
                      allowSearch={true}
                      allowSorting={true}
                      alignment={"center"}
                    />
                    <Column
                      dataField="assetScrapSubAttachment"
                      caption="Attachments"
                      alignment={"center"}
                      allowSorting={false}
                      allowSearch={false}
                      allowExporting={false}
                      allowFiltering={false}
                      cellRender={(cellData) => {
                        const attachments =
                          cellData.data.assetScrapSubAttachment || [];
                        if (!attachments.length) return <span>No Files</span>;
                        return (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                marginBottom: 4,
                                textAlign: "center",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "6px",
                              }}
                              title={attachments
                                .map((a) => a.fileName)
                                .join(", ")}
                              onClick={() => {}}
                            >
                              {attachments.map((file, index) => (
                                <>
                                  <a
                                    key={index}
                                    href={file.fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ cursor: "pointer", color: "blue" }}
                                    title={file.fileName}
                                  >
                                    {file.fileName}
                                  </a>
                                  {index < attachments.length - 1 && ", "}
                                </>
                              ))}
                            </div>
                            {/* <div
                              style={{
                                display: "flex",
                                gap: 10,
                                justifyContent: "center",
                              }}
                            >
                              <>
                                {attachments.map((a, index) => (
                                  <img
                                    key={index}
                                    src={a.fileUrl}
                                    alt={a.fileName}
                                    title={a.fileName}
                                    style={{
                                      width: 50,
                                      height: 50,
                                      objectFit: "cover",
                                      borderRadius: 4,
                                      border: "1px solid #ddd",
                                    }}
                                  />
                                ))}
                              </>
                            </div> */}
                          </div>
                        );
                      }}
                    />
                    <HeaderFilter visible={false} />
                    <Scrolling mode="virtual" />
                    <SearchPanel
                      visible={false}
                      highlightCaseSensitive={true}
                      width={240}
                      placeholder="Search..."
                    />
                  </DataGrid>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-3 reviews">
            <div className="card">
              <div className="card-body">
                <div className="mb-1 sub-title-color">REMARKS</div>
                <div class="list-group">
                  {assetScrapHistoryLst?.map((item, index) => (
                    <div
                      key={index}
                      className="list-group-item list-group-item-action flex-column align-items-start"
                      style={{
                        borderBottom: "1px solid #cfcfcf",
                        marginBottom: "0.5rem",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <div
                        className="small mb-1"
                        style={{ color: "#282c7d", fontWeight: "500" }}
                      >
                        {item.statusName === "Recall"
                          ? "Recall Requested"
                          : item.statusName}{" "}
                        by {item.userName}
                      </div>
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <small>Message</small>
                        <small>
                          {item.remarkDate
                            ? moment(item.remarkDate)
                                .format(
                                  DefaultDateFormat.MomentDisplayDateFormat
                                )
                                .toString()
                            : ""}
                        </small>
                      </div>
                      <div
                        className="small"
                        style={{ fontSize: "0.8rem", fontStyle: "italic" }}
                      >
                        {item.remark}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {assetScrapRequestInfo?.assetScrapAttachment?.length === 0 ? (
              ""
            ) : (
              <div className="card">
                <div className="card-body">
                  <div className="mb-1 sub-title-color">ATTACHMENTS</div>
                  {assetScrapRequestInfo?.assetScrapAttachment?.map(
                    (item, index) => (
                      <div class="list-group">
                        <div
                          key={index}
                          className="list-group-item list-group-item-action flex-column align-items-start"
                          style={{
                            borderBottom: "1px solid #cfcfcf",
                            marginBottom: "0.5rem",
                            paddingBottom: "0.5rem",
                          }}
                        >
                          <div class="d-flex w-100 justify-content-between align-items-center">
                            <small
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={() => {
                                window.open(item?.fileUrl, "_blank");
                              }}
                            >
                              {item?.fileName}
                              {/* item?.fileType */}
                            </small>
                            <small>{item?.fileSize} kb</small>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="web-page-footer">www.vishwasamudra.in</div>
      </div>
    </>
  );
}
